export const TravelAccidentIcon = (props) => (
  <svg
    className={props.className}
    width="17"
    height="22"
    viewBox="0 0 17 22"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M3.15303 8.67059C3.15303 8.23524 3.50595 7.88232 3.94129 7.88232H12.8749C13.3102 7.88232 13.6632 8.23524 13.6632 8.67059C13.6632 9.10592 13.3102 9.45885 12.8749 9.45885H3.94129C3.50595 9.45885 3.15303 9.10592 3.15303 8.67059Z"
      fill="#212121"
    />
    <path
      d="M3.15303 11.7117C3.15303 11.2764 3.50595 10.9235 3.94129 10.9235H12.8749C13.3102 10.9235 13.6632 11.2764 13.6632 11.7117C13.6632 12.1471 13.3102 12.5 12.8749 12.5H3.94129C3.50595 12.5 3.15303 12.1471 3.15303 11.7117Z"
      fill="#212121"
    />
    <path
      d="M5.25507 1.57652H4.99232C4.55698 1.57652 4.20406 1.2236 4.20406 0.788261C4.20406 0.35292 4.55698 0 4.99232 0H11.8239C12.2592 0 12.6122 0.35292 12.6122 0.788261C12.6122 1.2236 12.2592 1.57652 11.8239 1.57652H11.5612V3.15304H13.4004C15.2869 3.15304 16.8162 4.68234 16.8162 6.56884V16.028C16.8162 17.826 15.4269 19.2997 13.6632 19.4338V20.232C13.6632 20.6674 13.3103 21.0203 12.8749 21.0203C12.4396 21.0203 12.0867 20.6674 12.0867 20.232V19.4438H4.72957V20.232C4.72957 20.6674 4.37665 21.0203 3.94131 21.0203C3.50596 21.0203 3.15304 20.6674 3.15304 20.232V19.4338C1.38933 19.2997 0 17.826 0 16.028V6.56884C0 4.68234 1.5293 3.15304 3.4158 3.15304H5.25507V1.57652ZM6.8316 1.57652V3.15304H9.98464V1.57652H6.8316ZM13.4004 17.8672C14.4162 17.8672 15.2397 17.0438 15.2397 16.028V6.56884C15.2397 5.55304 14.4162 4.72957 13.4004 4.72957H3.4158C2.39999 4.72957 1.57652 5.55304 1.57652 6.56884V16.028C1.57652 17.0438 2.39999 17.8672 3.4158 17.8672H13.4004Z"
      fill="#212121"
    />
  </svg>
);
